export default __webpack_public_path__ + "static/media/sun.407bd7e8.png";